export default __webpack_public_path__ + "static/media/rosia_3.3006c994.jpeg";